import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { configAPI } from '../services/api';
import { toast } from 'sonner';
import { useLiveBarOffset } from '../hooks/useLiveBarOffset';

const SupportButton = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showOfflineModal, setShowOfflineModal] = useState(false);
  const liveBarOffset = useLiveBarOffset();

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const response = await configAPI.get();
      setConfig(response.data);
    } catch (error) {
      console.error('Erro ao carregar config do suporte:', error);
    } finally {
      setLoading(false);
    }
  };

  // Não renderiza enquanto carrega ou se estiver desabilitado
  if (loading) return null;
  if (config?.support_button_enabled === false) return null;

  const isOnline = config?.support_button_online !== false; // default true
  const link = config?.support_button_link || 'https://api.whatsapp.com/send/?phone=5528999565056';

  const handleClick = (e) => {
    if (!isOnline) {
      e.preventDefault();
      setShowOfflineModal(true);
    }
  };

  return (
    <>
      <a
        href={isOnline ? link : '#'}
        target={isOnline ? '_blank' : undefined}
        rel={isOnline ? 'noopener noreferrer' : undefined}
        onClick={handleClick}
        style={{ bottom: 24 + liveBarOffset }}
        className={`fixed right-6 ${
          isOnline 
            ? 'bg-green-500 hover:bg-green-600 cursor-pointer' 
            : 'bg-gray-400 hover:bg-gray-500 cursor-pointer'
        } text-white rounded-full p-4 shadow-lg transition-all hover:scale-110 z-50 flex items-center gap-2`}
        data-testid="support-button"
        title={isOnline ? 'Suporte Online' : 'Suporte Offline'}
      >
        <div className="relative">
          <MessageCircle className="w-6 h-6" />
          {/* Indicador de status */}
          <span 
            className={`absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-white ${
              isOnline ? 'bg-green-300 animate-pulse' : 'bg-gray-300'
            }`}
          />
        </div>
        <span className="hidden sm:inline text-sm font-medium">
          {isOnline ? 'Suporte' : 'Offline'}
        </span>
      </a>

      {/* Modal de Suporte Indisponível */}
      {showOfflineModal && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4"
          onClick={() => setShowOfflineModal(false)}
        >
          <div 
            className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl transform animate-in fade-in zoom-in duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botão fechar */}
            <button
              onClick={() => setShowOfflineModal(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>

            {/* Ícone */}
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                <MessageCircle className="w-8 h-8 text-gray-400" />
              </div>
            </div>

            {/* Título */}
            <h3 className="text-xl font-bold text-center text-gray-800 mb-2">
              Suporte Indisponível
            </h3>

            {/* Mensagem */}
            <p className="text-center text-gray-600 mb-6">
              No momento nosso suporte não está disponível. Por favor, retorne o contato mais tarde.
            </p>

            {/* Botão */}
            <button
              onClick={() => setShowOfflineModal(false)}
              className="w-full bg-gray-500 hover:bg-gray-600 text-white font-medium py-3 px-4 rounded-xl transition-colors"
            >
              Entendi
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportButton;
